import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=3b9f7295&scoped=true&"
import script from "./Seats.vue?vue&type=script&lang=ts&"
export * from "./Seats.vue?vue&type=script&lang=ts&"
import style0 from "./Seats.vue?vue&type=style&index=0&id=3b9f7295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f7295",
  null
  
)

export default component.exports